import findTMDB from "./findTMDB"
import searchTMDB from "./searchTMDB"

export default {
  findTMDB,
  searchTMDB
}
